import React, { Component } from 'react';
import { LoaderCircle } from 'lucide-react';

/**
 * Spinner Component
 * 
 * @example
 * <Spinner />
 * <Spinner size="small" />
 */
export default class Spinner extends Component {
    /**
     * @returns {string}
     */
    getSizeClass() {
        const sizeMap = {
            'small': 'size-8',
            'medium': 'size-12',
            'big': 'size-16',
        };

        return sizeMap[this.props.size] || 'size-12';
    }

    render() {
        const sizeClass = this.getSizeClass();
        const className = `${sizeClass} text-muted-foreground animate-spin ${this.props.className || ''}`.trim();

        return (
            <div className="flex items-center justify-center">
                <LoaderCircle
                    role="status"
                    aria-label="Loading"
                    className={className}
                />
            </div>
        );
    }
}

Spinner.defaultProps = {
    size: 'medium',
    className: '',
};
